import { Capacitor, registerPlugin } from '@capacitor/core';

type PlayStoreAvailabilityPlugin = {
	isPlayStoreUsable: () => Promise<{ usable: boolean }>;
};

const PlayStoreAvailability = registerPlugin<PlayStoreAvailabilityPlugin>('PlayStoreAvailability');

/**
 * Whether Play Core in-app update APIs are safe to call on this device/profile.
 * iOS / web always return true (Play Store is Android-only).
 * On Android, fails closed if the native plugin is unavailable or rejects.
 */
export async function isPlayStoreUsableForUpdates(): Promise<boolean> {
	if (Capacitor.getPlatform() !== 'android') {
		return true;
	}

	try {
		const { usable } = await PlayStoreAvailability.isPlayStoreUsable();
		return usable;
	} catch {
		return false;
	}
}
